var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-list"},[(_vm.isMobileDevice)?_c('div',{staticClass:"member-list__mobile"},[(!_vm.data.length)?_c('EmptyStateTable',{attrs:{"text":_vm.$t('common.components.table.empty')}}):_vm._e(),_vm._l((_vm.data),function(item,index){return _c('TableCard',{key:index,attrs:{"data":{
        title: item.customer.name,
        headerTitle: _vm.$t('offers.detail.members.lastActivity', {
          date: item.date
        }),
        list: [
          {
            topic: _vm.$t('offers.detail.members.redemptionDate'),
            description: item.redemptionDate
          },
          {
            topic: _vm.$t('offers.detail.members.location'),
            description: item.location
          }
        ]
      },"variant":"outlined"},on:{"click":function($event){return _vm.$emit('item-click', item.id)}},scopedSlots:_vm._u([{key:"header-right",fn:function(){return [_c('span',{class:[
            'member-list__mobile__status',
            'member-list__status-indicator',
            {
              'member-list__status-indicator--active': _vm.isActiveStatus(
                item.status
              )
            }
          ]},[_vm._v("\n          "+_vm._s(_vm.upperCaseFirstLetter(_vm.statusLabel(item.status)))+"\n        ")])]},proxy:true}],null,true)})})],2):_c('Table',{attrs:{"empty":!_vm.data.length}},[_c('thead',[_c('TableRow',{attrs:{"clickable":false}},_vm._l((_vm.headers),function(header){return _c('TableHeader',{key:header.name,attrs:{"sortable":header.field !== 'none',"sortField":_vm.sortField,"sortOrder":_vm.sortOrder,"sortKey":header.field,"padding":header.padding},on:{"sort":function($event){return _vm.$emit('handle-sort', $event)}}},[_vm._v("\n          "+_vm._s(header.name)+"\n        ")])}),1)],1),_c('tbody',_vm._l((_vm.data),function(item,index){return _c('TableRow',{key:index,staticClass:"member-list__activity-row",on:{"click":function($event){return _vm.$emit('item-click', item.id)}}},[_c('TableCell',[_c('div',{staticClass:"member-list__cell-container"},[_c('span',[_vm._v(_vm._s(item.customer.name))])])]),_c('TableCell',[_c('div',{staticClass:"member-list__cell-container"},[_c('span',[_vm._v(_vm._s(item.redemptionDate))])])]),_c('TableCell',[_c('div',{staticClass:"member-list__cell-container"},[_c('span',[_vm._v(_vm._s(item.location))])])]),_c('TableCell',[_c('div',{class:[
              'member-list__cell-container',
              'member-list__status-indicator',
              {
                'member-list__status-indicator--active': _vm.isActiveStatus(
                  item.status
                )
              }
            ]},[_c('span',[_vm._v(_vm._s(_vm.statusLabel(item.status)))])])])],1)}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }